<div appOutOfScreen (appOutOfScreen)="handleOutOfScreen($event)" #errorRef>
<nx-error *ngIf="navigationError$ | async" class="navigation-error nx-margin-bottom-xs" [ngClass]="['navigation-error--position-' + position]">
  <b>{{ (navigationError$ | async) || 'common.navigation-error.generic' | translate }}</b>
  <button nxPlainButton class="navigation-error--close" type="button" (click)="handleClose()">
    <nx-icon name="close" size="auto"></nx-icon>
  </button>
</nx-error>
</div>
